import styled from 'styled-components';

export const SelectWrap = styled.div`
	.search {
		height: 54px;
		padding: 10px;
		.ant-input-affix-wrapper {
			:hover,
			:focus {
				background-color: #fff;
			}
		}
		.ant-input {
			/* width: 180px;
			height: 32px;
			border-radius: 4px;
			border: 1px solid #ebecf0; */
			:hover,
			:focus {
				background-color: #fff;
			}
		}
	}
	.divider {
		width: 100%;
		height: 1px;
		background-color: #dfe1e6;
	}
`;
export const EmptyWrap = styled.div`
	text-align: center;
	width: 100%;
	padding: 30px 0;
	> div {
		text-align: center;
	}
	> img {
		width: 52px;
		height: 54px;
	}
`;
